// eslint-disable-next-line
import { RouteView } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'

export const distributionRouter = [
  {
    path: '/distribution',
    redirect: '/distribution/memberList',
    component: RouteView,
    meta: { title: '分销', icon: 'share-alt' },
    name:"distributionGroup",
    children: [
      {
        path: '/service/union',
        component: RouteView,
        redirect: '/distribution/memberList',
        meta: { title: '分销联盟', keepAlive: true },
        name:"distributionUnion",
        children: [
          {
            path: '/distribution/memberList',
            name: 'MemberList',
            component: () => import('@/views/distribution/member/MemberList'),
            meta: { title: '成员列表' }
          },
          {
            hidden: true,
            path: '/distribution/commissionRecord',
            name: 'CommissionRecord',
            component: () => import('@/views/distribution/member/CommissionRecord'),
            meta: { title: '佣金记录', hideInMenu: true }
          },
          {
            hidden: true,
            path: '/distribution/createMember',
            name: 'CreateMember',
            component: () => import('@/views/distribution/member/CreateMember'),
            meta: { title: '添加成员', hideInMenu: true, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            hidden: true,
            path: '/distribution/submitMemberAuth',
            name: 'SubmitMemberAuth',
            component: () => import('@/views/distribution/member/SubmitMemberAuth'),
            meta: { title: '提交成员认证', hideInMenu: true, ignorePermissions: true, keepAlive: false },
            ignorePermissions: true
          },
          {
            hidden: true,
            path: '/distribution/memberAuthDetail',
            name: 'MemberAuthDetail',
            component: () => import('@/views/distribution/member/MemberAuthDetail'),
            meta: { title: '成员认证详情', hideInMenu: true, ignorePermissions: true, keepAlive: false },
            ignorePermissions: true
          },
          {
            hidden: true,
            path: '/distribution/shopDetail',
            name: 'ShopDetail',
            component: () => import('@/views/distribution/member/ShopDetail'),
            meta: { title: '资料详情', hideInMenu: true, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            path: '/distribution/group/list',
            name: 'GroupList',
            component: () => import('@/views/distribution/group/GroupList'),
            meta: { title: '成员分组' }
          },
          {
            hidden: true,
            path: '/distribution/group/groupEditor',
            name: 'GroupCreator',
            component: () => import('@/views/distribution/group/GroupEditor'),
            meta: { title: '创建分组', hideInMenu: true, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            hidden: true,
            path: '/distribution/group/groupEditor',
            name: 'GroupEditor',
            component: () => import('@/views/distribution/group/GroupEditor'),
            meta: { title: '编辑分组', hideInMenu: true, ignorePermissions: true },
            ignorePermissions: true
          },
          {
            path: '/distribution/teamList',
            name: 'TeamInformationList',
            component: () => import('@/views/distribution/team/TeamInformationList'),
            meta: { title: '团队信息' }
          },
          {
            hidden: true,
            path: '/distribution/teamDetail',
            name: 'TeamInformationDetail',
            component: () => import('@/views/distribution/team/TeamInformationDetail'),
            meta: { title: '团队信息详情', keepAlive: false, hideInMenu: true }
          }
        ]
      }
    ]
  }
]